<div class="quickflows-section">
    <div class="quickflows-section-header">
        <ycn-icon-search-autocomplete
                [appendToBody]="true"
                [searchType]="'quickflow_securities'"
                (submitHandler)="addItem($event)">
        </ycn-icon-search-autocomplete>
    </div>
    <div class="quickflows-labels-list" *ngIf="currentSecurity">
        <div class="btn btn-purple-tint"
             ycnTooltip
             [tooltipPlacement]="'left'"
             [tooltipTitle]="currentSecurity.securityName">
            <a href="{{ currentSecurity.securityUrl }}">
                {{ currentSecurity.displaySecurityId }}
            </a>
            <div class="btn btn-xs btn-circle btn-transparent btn-close"
                 (click)="deleteItem()">
                        <span>
                            <svg ycnIcon [name]="'icon-close-circle'"></svg>
                        </span>
            </div>
        </div>
    </div>
</div>
<div class="quickflows-section"
     *ngIf="!currentSecurity && !loadingCollection">
    <div class="get-started-small">
        <span>Search for a security</span>
        <span>to view Quickflows</span>
    </div>
</div>
<div class="quickflows-section"
     *ngIf="currentSecurity && availableQuickflows.length == 0 && !loadingCollection">
    <div class="get-started-small">
        <span>There are no quickflows available for</span>
        <span>the current selected security</span>
    </div>
</div>
<ng-container *ngIf="currentSecurity && !loadingCollection">
    <div class="quickflows-section" *ngFor="let quickflowsGroupedByCategory of availableQuickflows">
        <div *ngFor="let quickflowObj of quickflowsGroupedByCategory | keyvalue">
            <div class="quickflows-section-title" [textContent]="quickflowObj.key"></div>
            <div class="quickflows-list">
                <div *ngFor="let quickflow of quickflowObj.value">
                    <a class="quickflows-list-item" href="javascript:void(0)">
                        <span (click)="select(quickflow['id'])" [textContent]="quickflow['label']"></span>
                        <div class="btn btn-xs btn-circle btn-transparent btn-i"
                             *ngIf="quickflow['tooltip_text']"
                             ycnTooltip
                             [tooltipClasses]="['popover']"
                             [tooltipTitle]="quickflow['tooltip_text']">
                            <svg ycnIcon [name]="'icon-info'"></svg>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</ng-container>
<ng-container *ngIf="loadingCollection">
    <div class="quickflows-section"
         *ngFor="let quickflow of availableQuickflows">
        <div class="quickflows-list options-list-skeleton">
            <div class="skeleton" style="width: 88%;"></div>
            <div class="skeleton" style="width: 40%;"></div>
            <div class="skeleton" style="width: 15%;"></div>
            <div class="skeleton" style="width: 65%;"></div>
        </div>
    </div>
</ng-container>
